export default "__VITE_ASSET__BlwzEm51__"